import { v4 as uuid } from "uuid"

/**
 * useUuid
 */
export const useUuid = () => React.useMemo(uuid, [])
